(function() {
  'use strict';
  
  angular
    .module('app.result')
    .config(statesConfig);
      
  statesConfig.$inject = ['$stateProvider'];
  
  function statesConfig($stateProvider) {
    $stateProvider
      .state('result', {
        params: {
          closeState: { type: 'string', value: null },
          closeStateParams: { type: 'json', value: null },
        },
        url: '/result/:mode/:resultId',
        templateUrl: 'app/result/result.html',
        controller: 'ResultController as vm',
        redirectTo: function(transition) {
          var settings = transition.injector().get('settings');
          return settings.get('shell.result.hideByDefault', false)
            ? 'result.hidden'
            : 'result.shown';
        }
      })
      .state('result.hidden', {
        url: '/hidden',
        templateUrl: 'app/result/result.hidden.html'
      })
      .state('result.shown', {
        templateUrl: 'app/result/result.shown.html'
      })
      .state('result.resume', {
        params: { targetEvent: { type: 'any' }},
        onEnter: [
            '$log',
            '$state',
            '$stateParams',
            '$mdDialog',
            'resultService',
            function($log, $state, $stateParams, $mdDialog, resultService) {
              var confirm = $mdDialog.confirm()
                .title('No Longer Active')
                .content('The poll you are trying to view results for is no longer active. ')
                .ok('Resume')
                .cancel('Cancel');
              $mdDialog.show(confirm).then(
                // Resume
                function() {
                  resultService.resume($stateParams.resultId).then(
                    function(activation) {
                      $log.debug('activation = ', activation);
                      $state.go('result', { activationId: activation._id });
                    },
                    $log.error
                  );
                },
                // Cancel
                function() {
                  $state.go('myPolls');
                }
              )
              // temp fix for https://github.com/angular/material/issues/10369
              .catch(angular.noop);
            }
          ]
      });
  }
  
})();